import { roboto, inter } from '../app/fonts';
import { NextFont } from 'next/dist/compiled/@next/font';
import { useMemo } from 'react';

export type FontFamily = 'inter' | 'playfairDisplay' | 'montserrat' | 'crimsonText' | 'geistSans' | 'geistMono' | 'roboto';

export const useFontFamily = (fontFamily: FontFamily) => {
  const styleFontFamily = useMemo(() => {
    const fonts: Record<string, NextFont> = {
      inter: inter,
      roboto: roboto,
      // playfairDisplay: playfairDisplay,
      // montserrat: montserrat,
      // crimsonText: crimsonText,
      // geistSans: geistSans,
      // geistMono: geistMono,
    };
    return fonts[fontFamily]?.className ?? 'roboto';
  }, [fontFamily]);

  return styleFontFamily;
};
